"use strict";

exports.__esModule = true;
exports.StripeChartBrushHandle = exports.HANDLE_WIDTH = exports.HANDLE_HEIGHT = exports.Edge = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = require("../../Theme");
var _whenModern = require("../../Theme/UiDesign/whenModern");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var HANDLE_HEIGHT = exports.HANDLE_HEIGHT = 20;
var HANDLE_WIDTH = exports.HANDLE_WIDTH = 60;
var Edge = exports.Edge = _styledComponents["default"].div.withConfig({
  displayName: "StripeChartBrushHandle__Edge",
  componentId: "sc-1blebj1-0"
})(["background:", ";height:", "px;word-wrap:break-word;color:", ";line-height:5px;font-size:16px;position:absolute;top:0px;width:6px;padding-left:1px;"], (0, _Theme.val)("BrushHandleEdgeBackground"), HANDLE_HEIGHT, (0, _Theme.val)("BrushHandleColor"));
var Handle = _styledComponents["default"].div.attrs(function (props) {
  return {
    style: {
      top: props.y + "px",
      left: props.x + "px",
      cursor: props.isLocked ? "default" : "ew-resize"
    }
  };
}).withConfig({
  displayName: "StripeChartBrushHandle__Handle",
  componentId: "sc-1blebj1-1"
})(["z-index:10;position:absolute;width:", "px;height:", "px;background-color:", ";", " color:", ";"], HANDLE_WIDTH, HANDLE_HEIGHT, (0, _Theme.val)("BrushHandleBackground"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["font-family:", ";font-size:11px;font-weight:600;line-height:", "px;padding:3px 6px;border-radius:4px;"], (0, _Theme.val)("ChartFontFamilyMono"), HANDLE_HEIGHT - 6), (0, _styledComponents.css)(["font-size:0.8em;padding:3px;"])), (0, _Theme.val)("BrushHandleColor"));
var LeftHandle = (0, _styledComponents["default"])(Handle).attrs(function (props) {
  return {
    style: {
      top: props.y + "px",
      left: props.x - HANDLE_WIDTH + "px",
      cursor: props.isLocked ? "default" : "ew-resize"
    }
  };
}).withConfig({
  displayName: "StripeChartBrushHandle__LeftHandle",
  componentId: "sc-1blebj1-2"
})(["text-align:right;", "{left:0px;text-align:left;", "}"], Edge, (0, _whenModern.whenModern)("border-radius: 4px 0 0 4px;"));
var RightHandle = (0, _styledComponents["default"])(Handle).withConfig({
  displayName: "StripeChartBrushHandle__RightHandle",
  componentId: "sc-1blebj1-3"
})(["", "{right:0px;", "}"], Edge, (0, _whenModern.whenModern)("border-radius: 0 4px 4px 0;"));
var defaultProps = {
  theme: undefined,
  isRightAligned: false,
  isLocked: false
};

/**
 * A brush handle to use with the StripeChartBrush
 */
var StripeChartBrushHandle = exports.StripeChartBrushHandle = /*#__PURE__*/function (_Component) {
  function StripeChartBrushHandle() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.dragStartX = 0;
    _this.handleMove = function (e) {
      var _this$props = _this.props,
        x = _this$props.x,
        onMove = _this$props.onMove,
        isLocked = _this$props.isLocked;
      e.stopPropagation();
      if (!isLocked) {
        // the difference between where we start dragging and the mouse
        var movedX = _this.dragStartX - e.clientX;
        if (onMove) {
          // move the x position by the relative mouse movement to get the new position
          onMove(x - movedX);
        }

        // update the new relative drag location so we don't get exponentially large movements
        // eslint-disable-next-line operator-assignment
        _this.dragStartX = _this.dragStartX - movedX;
      }
    };
    _this.handleBeginDrag = function (e) {
      var _this$props2 = _this.props,
        onMoveStart = _this$props2.onMoveStart,
        isLocked = _this$props2.isLocked;
      e.stopPropagation();
      e.preventDefault(); // prevents the text selection on drag

      if (!isLocked) {
        document.addEventListener("mouseup", _this.handleEndDrag, true);
        document.addEventListener("mousemove", _this.handleMove, true);
        _this.dragStartX = e.clientX;
        if (onMoveStart) {
          onMoveStart(e.clientX);
        }
      }
    };
    _this.handleEndDrag = function (e) {
      var _this$props3 = _this.props,
        onMoveFinished = _this$props3.onMoveFinished,
        isLocked = _this$props3.isLocked;
      e.stopPropagation();
      e.preventDefault();
      if (!isLocked) {
        document.removeEventListener("mousemove", _this.handleMove, true);
        document.removeEventListener("mouseup", _this.handleEndDrag, true);
        _this.dragStartX = 0;
        if (onMoveFinished) {
          onMoveFinished(e.clientX);
        }
      }
    };
    return _this;
  }
  _inheritsLoose(StripeChartBrushHandle, _Component);
  var _proto = StripeChartBrushHandle.prototype;
  _proto.render = function render() {
    var _this$props4 = this.props,
      x = _this$props4.x,
      y = _this$props4.y,
      label = _this$props4.label,
      isRightAligned = _this$props4.isRightAligned,
      isLocked = _this$props4.isLocked;
    var Handle = isRightAligned ? RightHandle : LeftHandle;
    return /*#__PURE__*/_react["default"].createElement(Handle, {
      "data-testid": "StripeChartBrushHandle",
      y: y,
      x: x,
      isLocked: isLocked,
      onMouseDown: this.handleBeginDrag
    }, !isLocked && /*#__PURE__*/_react["default"].createElement(Edge, null, "..."), /*#__PURE__*/_react["default"].createElement("span", null, label));
  };
  return StripeChartBrushHandle;
}(_react.Component);
StripeChartBrushHandle.defaultProps = defaultProps;